import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  message,
  Typography,
  Table,
  Space,
  Select,
  Modal, Form, Input
} from "antd";
import { t } from "i18next";
import i18n from "../../i18n";
import { useHistory, useLocation } from "react-router-dom";
import jwt, { JwtPayload } from "jsonwebtoken";
import {
  getTrackReg,
  TrackRegistrationModel,
  trackRegister,
  fetchTeams,
  TeamModel,
} from "../../api/track";
import { useAppSelector } from "../../store/hook";
import TeamEdit from "./editTeam";
import { newTeam, sendApplication } from "../../api/team"
import { login } from "../../api/login";
interface IPropJoinAndTeam {
  contestId: number;
  trackId: number;
  trackStatus?: number;
}
const { Option } = Select;
const { Title, Text } = Typography;

export const JoinAndTeam: React.FunctionComponent<IPropJoinAndTeam> = (
  prop
) => {
  const { contestId, trackId, trackStatus } = prop;
  const [form] = Form.useForm();
  const location = useLocation();
  const history = useHistory();
  const [visible, setVisible] = React.useState(false);
  const status = useAppSelector((state) => state.user.user);
  const key = useAppSelector((state) => state.user.key);
  const id = useAppSelector(
    (state) => (jwt.decode(state.user.key) as JwtPayload)?.id || 0
  );
  const [trackReg, setTrackReg] = useState<TrackRegistrationModel>();
  const [teams, setTeams] = useState<TeamModel[]>([]);
  useEffect(() => {
    if (status === "guest") {
          login(location.pathname);
        }
    if (contestId === -1 || trackId === -1) {
      history.push("/404");
    } else {
      getTrackReg(key, contestId, trackId)
        .then((data) => {
          setTrackReg(data);
        })
        .catch((err) => {
          console.log(err);
          setTrackReg(undefined);
        });
    }
  }, [location, status, key, id, history, contestId, trackId]);
  useEffect(() => {
    // if (key && trackReg && !trackReg.team) {
    if (key && trackReg) {
      fetchTeams(key, contestId, trackId).then((data) => {
        setTeams(data.data);
      });
    }
  }, [trackReg, key, contestId, trackId]);
  const JoinFunction = () => {
    if (key && contestId && trackId) {
      trackRegister(key, contestId, trackId)
        .then(() => {
          message.success("报名成功");
          getTrackReg(key, contestId, trackId)
            .then((data) => {
              setTrackReg(data);
            })
            .catch((err) => {
              console.log(err);
              setTrackReg(undefined);
            });
        })
        .catch((err: Error) => {
          message.error(`报名失败：${err}`);
        });
    }
  };

  const makeapply = (teamId: any) => {
    console.log(teamId)
    sendApplication(key, contestId, trackId, teamId).then(
      data => {
        message.info("申请成功")
      }
    ).catch(err => {
      console.log(err)
      message.info("申请失败" + err)
    })
  }
  const setvis = () => {
    setVisible(true)
  }
  const setunvis = () => {
    setVisible(false)
  }
  const onFinish = (teamName: any) => {
    // teamName.name
    // trackRegister(key, contestId, trackId).then(
    newTeam(key, contestId, trackId, teamName.name).then(
      data => {
        message.info("创建成功")
      }
    ).catch(err => {
      console.log(err)
      message.info("创建失败" + err)
    })
    setVisible(false)
  }
  const onFinishFailed = () => {
    message.error("创建失败，请联系管理员")
    setVisible(false)
  }
  const onOk = () => {
    form.submit();
  };

  const Join =
    trackStatus === 1 ? (
      <>
        <Title level={2}>{t("比赛报名")}</Title>
        <Divider />
        <p>
          <Text>
            {t("我已经阅读并理解了平台相关规则和比赛规则及政策，现在报名比赛")}
          </Text>
        </p>
        <Button type="primary" onClick={JoinFunction}>
          {t("比赛报名")}
        </Button>
      </>
    ) : (
      <>
        <Title level={2}>本赛段现在不接受报名，请尝试以下解决方案</Title>
        <Divider />
        <Text>1、使用晋级到本赛段的账号参赛</Text><br/>
        <Text>2、等待赛段报名开放</Text>
      </>
    );
  const JoinTeam = (
    <>

      <>

      </>

      <Modal
        title="注册"
        visible={visible}
        onOk={onOk}
        onCancel={setunvis}
        destroyOnClose
        maskClosable={false}
        keyboard={false}
      >
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label={t("队名")}
            name="name"
            rules={[{ required: true, message: '请输入您的队伍名' }, { pattern: /^[\u4E00-\u9FFFa-zA-Z0-9_]+$/, message: '用户名应为中文字符、英文字母、数字或下划线构成' }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>

      <Button onClick={
        setvis
      }
        type="primary"
      >{t("新建队伍")}</Button>



      <Divider />
      <Title level={2}>{t("队伍列表")}</Title>

      <Divider />

      <Table
        dataSource={teams}
        columns={
          [
            {
              title: t('队名'),
              dataIndex: 'teamName',
              key: 'teamName',
            },
            {
              title: t('学校'),
              dataIndex: 'schoolName',
              key: 'schoolName',
            },
            {
              title: t('队伍ID'),
              dataIndex: 'id',
              key: 'id',
              render: id => <a>{id}</a>,
            },
            {
              title: '',
              key: 'action',
              render: (id, record) => (
                <Button size="middle" onClick={
                  ()=>makeapply(record.id)
                }>
                  <a>{t("申请加入")}</a>
                </Button>
              ),
            },
          ]}

      ></Table>

    </>
  );
  return (
    <div className="site-layout-content">
      {!trackReg ? (
        Join
      ) : !trackReg.team ? (
        JoinTeam
      ) : (
        <TeamEdit
          contestId={contestId}
          trackId={trackId}
          teamId={trackReg.team}
        ></TeamEdit>
      )}
    </div>
  );
};

export default JoinAndTeam;
